<div class="modal-header">
  <h4 class="modal-title">Aprovar Matriz de Constatações Preliminar</h4>
  <button type="button" class="close" (click)="fechar()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        <label><strong>Avaliação *</strong></label>

        <div class="form-check">
          <input class="form-check-input"
                 type="radio"
                 formControlName="statusAvaliacao"
                 [value]="1"
                 id="aprovada">
          <label class="form-check-label" for="aprovada">
            Aprovada
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input"
                 type="radio"
                 formControlName="statusAvaliacao"
                 [value]="2"
                 id="rejeitada">
          <label class="form-check-label" for="rejeitada">
            Rejeitada
          </label>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <mat-form-field class="w-100">
          <mat-label>Comentário *</mat-label>
          <textarea matInput
                    formControlName="comentario"
                    rows="4"
                    maxlength="200"></textarea>

          <mat-hint align="end">
            {{ form.get('comentario')?.value?.length || 0 }} / 200
          </mat-hint>

          <mat-error *ngIf="form.get('comentario')?.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
    Cancelar
  </button>

  <button type="button"
          class="btn btn-primary "
          (click)="salvar()"
          [disabled]="!form.valid || loading">
    <i class="fas fa-check"></i> Salvar
  </button>
</div>
